import React, { useEffect, useState } from "react";
import { FaBell } from "react-icons/fa";
import { collection, query, where, onSnapshot, doc, getDoc } from "firebase/firestore";
import { auth, db } from "./firebase";
import { useNavigate } from "react-router-dom";
import { isNative } from "./utils/isNative";

function Navbar() {
  const [unreadCount, setUnreadCount] = useState(null); // null = non ancora sincronizzato con Firestore
  const navigate = useNavigate();
  
  // 🎯 Listener Firestore per contare le notifiche non lette
  useEffect(() => {
    console.log("🔔 [Navbar] Component mounted, setting up notification listener");
    let unsubscribe = () => {};
    let isActive = true; // Track if component is still mounted
    
    const unsubscribeAuth = auth.onAuthStateChanged(async (currentUser) => {
      console.log("🔔 [Navbar] Auth state changed, user:", currentUser?.uid || "null");
      // Always clean up previous listener first
      unsubscribe();
      
      if (currentUser && isActive) {
        console.log("🔔 [Navbar] Setting up Firestore listener for user:", currentUser.uid);
        // Subscribe to notifications
        const q = query(
          collection(db, "notifications"),
          where("recipientId", "==", currentUser.uid),
          where("isRead", "==", false)
        );
        unsubscribe = onSnapshot(q, (snapshot) => {
          console.log("🔔 [Navbar] Firestore snapshot received, unread count:", snapshot.size);
          if (isActive) {
            console.log("🔔 [Navbar] Updating unreadCount state to:", snapshot.size);
            setUnreadCount(snapshot.size);
          } else {
            console.log("🔔 [Navbar] Component inactive, skipping state update");
          }
        }, (error) => {
          // Suppress permission errors during logout
          if (isActive && error.code !== 'permission-denied') {
            console.error("🔔 [Navbar] Listener error:", error);
          }
        });
      } else {
        // User logged out - reset count
        console.log("🔔 [Navbar] No user, resetting unreadCount to 0");
        if (isActive) {
          setUnreadCount(0);
        }
      }
    });

    return () => {
      console.log("🔔 [Navbar] Component unmounting");
      isActive = false; // Mark as inactive first
      unsubscribe();
      unsubscribeAuth();
    };
  }, []);

  // 🎯 Sincronizza badge iOS con lo stato del pallino rosso (unreadCount > 0)
  useEffect(() => {
    // ⚠️ IMPORTANTE: Non fare nulla finché Firestore non ha caricato il primo snapshot
    if (unreadCount === null) {
      console.log('🔔 [Navbar] unreadCount ancora null, aspetto prima sincronizzazione Firestore');
      return;
    }

    const syncIosBadgeWithUnread = async () => {
      if (!isNative()) return;

      try {
        const { PushNotifications } = await import("@capacitor/push-notifications");
        const { Capacitor } = await import("@capacitor/core");
        
        const hasUnreadNotifications = unreadCount > 0;
        
        if (hasUnreadNotifications) {
          // Ci sono notifiche non lette: assicuriamoci che il badge sia visibile
          await PushNotifications.setBadgeCount({ count: unreadCount });
          console.log(`🔔 [Navbar] Badge iOS impostato a ${unreadCount} (hasUnread = true)`);
        } else {
          // Non ci sono più notifiche non lette: puliamo tutto
          
          // 1️⃣ Rimuovi notifiche consegnate dal Notification Center (solo se implementato)
          try {
            // Verifica se siamo su iOS e se il metodo è implementato
            if (Capacitor.getPlatform() === 'ios' && PushNotifications.removeAllDeliveredNotifications) {
              await PushNotifications.removeAllDeliveredNotifications();
              console.log('🔔 [Navbar] removeAllDeliveredNotifications chiamato (hasUnread = false)');
            } else {
              console.log('🔔 [Navbar] removeAllDeliveredNotifications non disponibile o non necessario su questa piattaforma');
            }
          } catch (removeErr) {
            // Ignora errori "UNIMPLEMENTED" - non tutti i metodi sono disponibili su tutte le piattaforme
            if (removeErr.message && removeErr.message.includes('UNIMPLEMENTED')) {
              console.log('🔔 [Navbar] removeAllDeliveredNotifications non implementato, skip');
            } else {
              console.warn('🔔 [Navbar] Errore chiamando removeAllDeliveredNotifications:', removeErr);
            }
          }

          // 2️⃣ Azzera il badge
          await PushNotifications.setBadgeCount({ count: 0 });
          console.log('🔔 [Navbar] Badge iOS azzerato (hasUnread = false)');
        }
      } catch (err) {
        console.error('🔔 [Navbar] Errore sincronizzando badge iOS:', err);
      }
    };

    syncIosBadgeWithUnread();
  }, [unreadCount]);

  

  console.log("🔔 [Navbar] Rendering with unreadCount:", unreadCount, "badge visible:", unreadCount > 0);
  
  return (
    <div style={navbarStyle}>
      <h1 style={titleStyle}>Wishare</h1>
      <div style={iconsContainerStyle}>
        <div style={bellWrapperStyle} onClick={() => {
          const currentPath = window.location.pathname;
          console.log("🔔 [Navbar] Bell clicked, navigating from:", currentPath);
          navigate("/notifications", { state: { from: currentPath === "/notifications" ? "/feed" : currentPath } });
        }}>
          <FaBell style={bellStyle} />
          {unreadCount > 0 && (
            <div style={badgeStyle}></div>
          )}
        </div>
      </div>
    </div>
  );
}

const navbarStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "35px 20px 15px 20px",
  backgroundColor: "#fff",
  borderBottom: "1px solid #eee",
  position: "sticky",
  top: 0,
  zIndex: 999,
};

const titleStyle = {
  fontSize: "24px",
  fontWeight: "bold",
  color: "#111",
  marginTop: "12px",
};

const iconsContainerStyle = {
  display: "flex",
  alignItems: "center",
};

const bellWrapperStyle = {
  position: "relative",
  cursor: "pointer",
  marginRight: "20px",
  marginTop: "12px",
};

const bellStyle = {
  fontSize: "20px",
  color: "#000",
};

const badgeStyle = {
  position: "absolute",
  top: "-3px",
  right: "-3px",
  background: "#ff4444",
  width: "8px",
  height: "8px",
  borderRadius: "50%",
  border: "1px solid #fff",
};



export default Navbar;